import {ProductFlagGenqlSelection} from "@/gql/gen";

export const ProductFlagFields: ProductFlagGenqlSelection = {
    ID: true,
    NAME: true,
    PROPERTIES: {
        __fragment: 'ProductFlagProps'
    }
}
